// eslint-disable-next-line max-classes-per-file
import { RealTimePlaybackKey } from '@ftr/data-realtime-playback'
import { LocalDateTime, LocalTime } from '@js-joda/core'
import {
  RealTimeSearchHighlights,
  RealTimeSttHearingMarker,
  RealTimeSttSealingMarker,
  RealTimeSttSessionMarker,
} from '../../types'
import { OperationField, ValidationErrorResult } from './edit-operations/operation-result'
import { RealTimeSttAction } from './real-time-stt.actions'

export abstract class RealTimeSttCommand implements RealTimeSttAction {
  readonly scope = 'STT_COMMAND'
  abstract playbackKey: RealTimePlaybackKey
}

export class RealTimeSttSetSearchHighlightsCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Set Search Highlights'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly searchHighlights: RealTimeSearchHighlights,
  ) {
    super()
  }
}

export class SetRealTimeSttCurrentPlaybackTimeCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Set RealTime Stt Current Playback Time'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly currentPlaybackTime: LocalDateTime,
  ) {
    super()
  }
}

export class SetRealTimeSttSessionMarkersCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Set RealTime Stt Session Markers'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly sessionMarkers: RealTimeSttSessionMarker[],
  ) {
    super()
  }
}

export class SetRealTimeSttSealingMarkersCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Set RealTime Stt Sealing Markers'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly sealingMarkers: RealTimeSttSealingMarker[],
  ) {
    super()
  }
}

export class SetRealTimeSttHearingMarkersCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Set RealTime Stt Hearing Markers'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly hearingMarkers: RealTimeSttHearingMarker[],
  ) {
    super()
  }
}

export class SetRealTimeRecordingEndTimeCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Set Recording End Time'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly recordingEndTime?: LocalDateTime,
  ) {
    super()
  }
}

export class UpdateRealTimeLiveLocalTimeCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Update Live Local Time'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly liveLocalTime?: LocalTime,
  ) {
    super()
  }
}

export class FocusEditableRemarkCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Focus editable remark'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly remarkId: string,
    readonly selectionIndex: number,
  ) {
    super()
  }
}

export class ShowValidationErrorRemarkCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Show validation error remark'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly remarkId: string,
    readonly validationError: ValidationErrorResult,
  ) {
    super()
  }
}

export class ResetRemarkFieldsCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Reset remark fields command'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly remarkId: string,
    readonly fields: OperationField[],
  ) {
    super()
  }
}

export class CaptureScrollPositionCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Capture Scroll Position'

  constructor(readonly playbackKey: RealTimePlaybackKey) {
    super()
  }
}

export class RestoreScrollPositionCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Restore Scroll Position'

  constructor(readonly playbackKey: RealTimePlaybackKey) {
    super()
  }
}

export class NotifyRemarkMovedCommand extends RealTimeSttCommand {
  static readonly type = '[RealTimeStt] Notify remark moved'

  constructor(
    readonly playbackKey: RealTimePlaybackKey,
    readonly remarkId: string,
    readonly segmentId: string,
  ) {
    super()
  }
}

export class RealTimeSttRefreshCommand {
  static readonly type = '[RealTimeStt] Refresh'

  constructor(readonly playbackKey: RealTimePlaybackKey) {}
}
